import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { ContainerStationDetailFragmentDoc } from '../fragments/containerStationDetail.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateContainerStationMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
  name: Types.Scalars['String'];
  type_id: Types.Scalars['Int'];
  is_recalled: Types.Scalars['Boolean'];
}>;


export type UpdateContainerStationMutation = { __typename?: 'Mutation', updateContainerStation: { __typename?: 'ContainerStation', id: string, name: string, store_id: string, epc_tag: string, is_recalled: boolean, item_type: { __typename?: 'ItemType', id: number, name: string, color_hex_code?: string | null, category: Types.ItemTypeCategory, epc_asset_id: number, image_url?: string | null }, store: { __typename?: 'Store', id: string, name?: string | null }, stock: Array<{ __typename?: 'ContainerStationStock', id: number, name: string, amount: number, image_url?: string | null, sealed: boolean }> } };


export const UpdateContainerStationDocument = gql`
    mutation UpdateContainerStation($id: ID!, $name: String!, $type_id: Int!, $is_recalled: Boolean!) {
  updateContainerStation(
    id: $id
    name: $name
    type_id: $type_id
    is_recalled: $is_recalled
  ) {
    ...ContainerStationDetail
  }
}
    ${ContainerStationDetailFragmentDoc}`;
export type UpdateContainerStationMutationFn = Apollo.MutationFunction<UpdateContainerStationMutation, UpdateContainerStationMutationVariables>;

/**
 * __useUpdateContainerStationMutation__
 *
 * To run a mutation, you first call `useUpdateContainerStationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContainerStationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContainerStationMutation, { data, loading, error }] = useUpdateContainerStationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      type_id: // value for 'type_id'
 *      is_recalled: // value for 'is_recalled'
 *   },
 * });
 */
export function useUpdateContainerStationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContainerStationMutation, UpdateContainerStationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContainerStationMutation, UpdateContainerStationMutationVariables>(UpdateContainerStationDocument, options);
      }
export type UpdateContainerStationMutationHookResult = ReturnType<typeof useUpdateContainerStationMutation>;
export type UpdateContainerStationMutationResult = Apollo.MutationResult<UpdateContainerStationMutation>;
export type UpdateContainerStationMutationOptions = Apollo.BaseMutationOptions<UpdateContainerStationMutation, UpdateContainerStationMutationVariables>;